import React from 'react';
import { Box, Chip, CircularProgress, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BRAND } from '../../theme/brandTheme';

const STATUS_STYLES = {
  Canlı: { color: BRAND.green, bg: `${BRAND.green}14`, border: `${BRAND.green}55` },
  Taslak: { color: '#64748B', bg: '#F1F5F9', border: '#CBD5E1' },
  Durduruldu: { color: '#D97706', bg: '#FFFBEB', border: '#FCD34D' },
};

/** Status selector — chip style for modern report list */
const StatusDropdown = ({
  test,
  isOpen,
  isLoading,
  canChangeStatus,
  onToggle,
  onStatusChange,
  variant = 'legacy',
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const statusOptions = ['Canlı', 'Durduruldu', 'Taslak'];
  const style = STATUS_STYLES[test.status] || STATUS_STYLES.Taslak;

  React.useEffect(() => {
    if (!isOpen) setAnchorEl(null);
  }, [isOpen]);

  const handleOpen = (e) => {
    e.stopPropagation();
    if (!canChangeStatus || isLoading) return;
    setAnchorEl(e.currentTarget);
    onToggle(test.id, e);
  };

  const handleClose = (e) => {
    e?.stopPropagation?.();
    setAnchorEl(null);
    if (isOpen) onToggle(test.id, { stopPropagation: () => {} });
  };

  const handleSelect = (status) => {
    setAnchorEl(null);
    onStatusChange(test.id, status);
  };

  // Legacy CSS variant for popup / old views
  if (variant === 'legacy') {
    return (
      <div className="status-dropdown">
        {isLoading ? (
          <span className="status status-loading">
            <div className="spinner" />
          </span>
        ) : (
          <span
            className={`status status-${test.status} ${canChangeStatus ? 'clickable' : ''}`}
            onClick={(e) => onToggle(test.id, e)}
          >
            {test.status}
          </span>
        )}
        {canChangeStatus && isOpen && (
          <div className="dropdown-content" style={{ display: 'block' }}>
            {statusOptions.map((status) => (
              <div
                key={status}
                className={`dropdown-item ${status === test.status ? 'selected' : ''}`}
                onClick={() => onStatusChange(test.id, status)}
              >
                {status}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 88, height: 28 }}>
        <CircularProgress size={18} sx={{ color: BRAND.purple }} />
      </Box>
    );
  }

  return (
    <>
      <Chip
        label={test.status}
        size="small"
        icon={canChangeStatus ? <KeyboardArrowDownIcon sx={{ fontSize: '16px !important' }} /> : undefined}
        onClick={handleOpen}
        sx={{
          height: 28,
          fontWeight: 600,
          fontSize: 12,
          bgcolor: style.bg,
          color: style.color,
          border: `1px solid ${style.border}`,
          cursor: canChangeStatus ? 'pointer' : 'default',
          '& .MuiChip-icon': { color: style.color, ml: 0.5 },
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: { minWidth: 140, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', borderRadius: 2 },
        }}
      >
        {statusOptions.map((status) => {
          const optStyle = STATUS_STYLES[status];
          return (
            <MenuItem
              key={status}
              selected={status === test.status}
              onClick={() => handleSelect(status)}
              sx={{
                fontSize: 13,
                fontWeight: status === test.status ? 600 : 400,
                color: optStyle.color,
              }}
            >
              {status}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default StatusDropdown;
